import React from 'react'
import ProfileMobileServiceUsersContainer from '../../containers/ProfileMobileContainer/ProfileMobileServiceUsersContainer'

const ProfileMobileServiceUsersPage = () => {
    return <ProfileMobileServiceUsersContainer/>
}
export default ProfileMobileServiceUsersPage;